import Rx from 'rx';
import moment from 'moment';

export default function MemberPayablesCtrl($scope, WampCall, progressBar, $state, $anchorScroll, $mdMedia) {

  var uri = 'org.eggs.payable_list';
  var vm = this;

  vm.mdMedia = $mdMedia;

  var items = $scope.$createObservableFunction('refresh')
      .startWith('nothing')
      .do(function () {
        vm.trades = [];
        vm.loadingEgg = true;
        vm.noItems = false;
        progressBar.add(uri);
      })
      .flatMap(function () {
        return new WampCall(uri);
      })
      .do(function () {
        progressBar.remove(uri);
      })
      .flatMap(function (trades) {
        return Rx.Observable.from(trades)
            .map(function (trade) {
              trade.Balance = trade.Balance * -1; //Convert negative to
                                                  // positive
              return trade;
            })
            .toArray();
      });

  var s1 = items
      .safeApply($scope, function (trades) {
        vm.trades = trades;
        vm.lastUpdated = moment();

        if (trades.length === 0) {
          vm.noItems = true;
        }
        else {
          vm.loadingEgg = false;
        }
      })
      .subscribe(
          function () {
            if ($state.params.id) {
              $anchorScroll('trade' + $state.params.id);
            }
          },
          function ($e) {
            vm.noItems = true;
            progressBar.remove(uri);
          });

  $scope.$on('$destroy', function () {
    s1.dispose();
    progressBar.remove(uri);
  });
}
